
<div class="main-content">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <h4>{{this.translate.data['TENANTS'] | translate}}</h4>             
                <div class="clearfix"></div>
            </div>

            <!-- <div class="card-body">
                <h2>TEST card-body</h2>
            </div>
            <div class="card-header">
                <h2>TEST card-header</h2>
            </div> -->


            <div class="card-body">     
                <div class="row">
                    <div class="col-md-8">
                        <a>
                        <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['ADDTENANT'] | translate}}"
                                        (click)="addTenant()" [hidden]="!_tenant">Neuer Mandant</button>
                        </a>                   
                    </div>
                </div>
           
                <div class="user-board-body-table">
                    <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                        <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                            Squirrel's API rate limit has been reached. It will be reset in one minute.
                        </div>
                    </div>
                    <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: 100%;  padding: 5px;"
                        [overlayLoadingTemplate]="overlayLoadingTemplate"
                        [gridOptions]="gridOptions" 
                        (gridReady)="onGridReady($event)"
                        [frameworkComponents]="frameworkComponents" 
                        [rowData]="rowData">
                    </ag-grid-angular>
                </div>
            </div>            
        </div>
    </div>
</div>



